export const deviceInventory = {

  singleFanDetail:
  {
    columnDefinitions: [
      {
        caption: 'Wireless user', field: 'ctnNumber', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
      },
      {
        caption: 'IMEI', field: 'imei', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 4, customTemplate: 'callBackImei'
      },
      {
        caption: 'Device model', field: 'model', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 3, customTemplate: ''
      },
      {
        caption: 'Status', field: 'status', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 2, customTemplate: 'callBackProfileStatus'
      }
      ,
      {
        caption: 'Group', field: 'groupName', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 5, customTemplate: ''
      }
    ],
  },

  singleFanDetailOEM:
  {
    columnDefinitions: [
      {
        caption: 'Device Identifier(s)', field: 'ctnNumber', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
      },
      // {
      //   caption: 'IMEI', field: 'imei', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
      //   enableSorting: true, enableFilter: false, cssClass: '', priority: 4, customTemplate: 'callBackImei'
      // },
      {
        caption: 'Device model', field: 'model', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 3, customTemplate: ''
      },
      {
        caption: 'Reason', field: 'enrollmentStatusReason', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 6, customTemplate: ''
      },
      {
        caption: 'Status', field: 'status', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 2, customTemplate: 'callBackProfileStatusoem'
      }
      ,
      {
        caption: 'Group', field: 'groupName', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: '', priority: 5, customTemplate: ''
      }
    ],
  },
  reviewGroupDevices:
  {
    columnDefinitions: [
      {
        caption: 'Wireless User', field: 'ctnNumber', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: false, enableFilter: false, cssClass: 'wireless-col', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
      },
      {
        caption: 'IMEI', field: 'imei', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: false, enableFilter: false, cssClass: 'wireless-col', priority: 4, customTemplate: 'callBackImei'
      },
      {
        caption: 'Device Model', field: 'model', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: false, enableFilter: false, cssClass: 'wireless-col', priority: 3, customTemplate: ''
      },
      {
        caption: 'Status', field: 'status', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: false, enableFilter: false, cssClass: '', priority: 2, customTemplate: 'callBackProfileStatus'
      },
      {
        caption: 'Group', field: 'group', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: false, enableFilter: false, cssClass: 'wireless-col', priority: 5, customTemplate: ''
      }
    ],
  },
  selectDevices:
  {
    columnDefinitions: [
      {
        caption: 'Wireless User', field: 'ctnNumber', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'wireless-col wireless-align', priority: 1, customTemplate: 'callBackAppNameCellTemplate'
      },
      {
        caption: 'IMEI', field: 'imei', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'wireless-col', priority: 4, customTemplate: 'callBackImei'
      },
      {
        caption: 'Device Model', field: 'model', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'wireless-col', priority: 3, customTemplate: ''
      },
      {
        caption: 'Status', field: 'status', type: 'CUSTOMTEMPLATE', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'status-cols', priority: 5, customTemplate: 'callBackProfileStatus'
      },
      {
        caption: 'Group', field: 'group', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'wireless-col-grp', priority: 5, customTemplate: ''
      }
    ],
  },
  trackingPageDetails:
  {
    columnDefinitions: [
      {
        caption: 'IMEI', field: '_id', type: 'TEXT', sortDirection: 'Asc', width: 155,
        enableSorting: true, enableFilter: false, cssClass: 'imeiWidth', customTemplate: 'callBackAppNameCellTemplate'
      },
      {
        caption: 'Model', field: 'model', type: 'TEXT', sortDirection: 'Asc', width: 80,
        enableSorting: true, enableFilter: false, cssClass: 'modelSubEnrollWidth', customTemplate: 'callBackImei'
      },
      {
        caption: 'Manufacturer', field: 'manufacturer', type: 'TEXT', sortDirection: 'Asc', width : 125,
        enableSorting: true, enableFilter: false, cssClass: 'manufacturerWidth', customTemplate: ''
      },
      {
        caption: 'Date Added', field: 'createdAt', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'headerWidth', customTemplate: 'callBackProfileStatus'
      }
      ,
      {
        caption: 'Last Updated', field: 'lastUpdatedAt', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'dateWidth', customTemplate: ''
      }
      ,
      {
        caption: 'Last Event Type', field: 'eventType', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'headerWidth', customTemplate: 'callBackAppNameCellTemplate'
      },
      {
        caption: 'Last Event Response', field: 'currentStatus', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: false, cssClass: 'headerWidth', customTemplate: 'callBackImei'
      },
      {
        caption: 'Last Response Status', field: 'cdfStatus', type: 'TEXT', sortDirection: 'Asc', width : 120,
        enableSorting: true, enableFilter: false, cssClass: 'statusWidth', customTemplate: ''
      },
      {
        caption: 'Sub Status', field: 'subStatus', type: 'TEXT', sortDirection: 'Asc', width : 80,
        enableSorting: true, enableFilter: false, cssClass: 'modelSubEnrollWidth', customTemplate: ''
      },
      {
        caption: 'Enrollment Status Reason', field: 'enrollmentStatusReason', type: 'TEXT', sortDirection: 'Asc', width : 80,
        enableSorting: true, enableFilter: false, cssClass: 'modelSubEnrollWidth', customTemplate: ''
      },
      {
        caption: 'Action', cssClass : 'hideAction'
      }
    ],
  },
};
 
